import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { AppUserClaimsService } from '../services/app-user-claims.service';
import { UserRoles } from '../constants/constants';
import { FeatureToggleService } from '../services/feature-toggle.service';
import { AdminService } from '../services/admin.service';

@Injectable({
    providedIn: 'root'
})

export class MiVBManagementGuard  {
    allowedRoutes = ['systemSettings']
    constructor(
        private route: Router,
        private appUserClaimsSvc: AppUserClaimsService,
        private adminService: AdminService,
        private featureToggleService: FeatureToggleService
    ) {}

    canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        const claims = this.appUserClaimsSvc.getClaims();
        const assumed = this.appUserClaimsSvc.isAssumedRole();

        if ( claims.role === UserRoles.ACCOUNT_ADMIN || assumed ) {
            if ( this.allowedRoutes.includes(route.data['path']) )
            {
                // need to also check for Gateway and MiVoice Business in tags
                return this.adminService.getAccountTags(route.params.id).then( tags => {
                    //Code Warning: concern was raised in CLSD-4098
                    if ( tags && tags.mivb && tags.mivb.setup == true )
                        return true;
                    return false;
                });
            }
        }

        /*
        Retaining the Hybrid apps access which is only available locally
        At this time, accessing the routes for the mivb hybrid apps will not be permitted
        unless running locally - since you need to run the hybrid app locally
        */
        if ( window.location.href.indexOf('dev-accounts.mitel.io:4200') > 0 )
        {
            return Promise.resolve(true);
        }
        else 
        {
            console.log("MiVB hybrid app not permitted");
            this.route.navigate(['navigationError']);
            return Promise.resolve(false);
        }
    }
}